import * as z from "zod";
import {
  regexNameWithAnd,
  regexTelephone,
  regexSurnameExclusions,
  regexFornameExclusions,
} from "@fwa/src/utils/formUtils";

import { addressValidation } from "@fwa/src/validation/address";
import { suppresionValidation } from "@fwa/src/validation/suppressions";

export const fundraiserValidation = z
  .object({
    title: z.enum(["", "Mr", "Mrs", "Miss", "Ms", "Mx", "Other"]).optional(),
    titleOther: z
      .string()
      .min(2, "Title should be at least 2 characters long.")
      .max(50, "Title should be at most 50 characters long.")
      .regex(regexNameWithAnd.pattern, `Title ${regexNameWithAnd.message}`)
      .optional(),
    forename: z
      .string()
      .trim()
      .min(1, "First name field is required.")
      .min(
        2,
        "First name should be at least 2 characters long. You can add a different name on your donation later.",
      )
      .max(
        50,
        "First name should be at most 50 characters long. You can add a different name on your donation later.",
      )
      .regex(regexFornameExclusions.pattern, regexFornameExclusions.message)
      .regex(
        /^(?!.*(^and | and | and$|&|\+))/i,
        "Please enter only one person's name.",
      )
      .regex(
        regexNameWithAnd.pattern,
        `First name ${regexNameWithAnd.message} You can add a different name on your donation later.`,
      ),
    surname: z
      .string()
      .trim()
      .min(1, "Last name field is required.")
      .min(
        2,
        "Last name should be at least 2 characters long. You can add a different name on your donation later.",
      )
      .max(
        50,
        "Last name should be at most 50 characters long. You can add a different name on your donation later.",
      )
      .regex(regexSurnameExclusions.pattern, regexSurnameExclusions.message)
      .regex(
        /^(?!.*(^and | and | and$|&|\+))/i,
        "Please enter only one person's name.",
      )
      .regex(
        regexNameWithAnd.pattern,
        `Last name ${regexNameWithAnd.message} You can add a different name on your donation later.`,
      ),
    phoneNumber: z
      .string()
      .transform((value) => value.replace(/\s+/g, ""))
      .pipe(
        z
          .string()
          .trim()
          .min(1, "Phone number field is required.")
          .min(10, "Phone number should be at least 10 characters long.")
          .max(16, "Phone number should be at most 16 characters long.")
          .regex(regexTelephone.pattern, regexTelephone.message),
      ),
    // Address
    address: addressValidation,
    suppressions: suppresionValidation,
  })
  .refine(
    // custom title
    (data) =>
      data.title === "Other" ? (data.titleOther?.length || 0) >= 2 : true,
    {
      error: "Title should be at least 2 characters long.",
      path: ["titleOther"],
    },
  );

export default fundraiserValidation;
